/* ==========================================================================
   Featured Product Section
   - Quantity stepper
   - Variant selection (updates price + enables Add to cart)
   - AJAX add to cart, then opens the existing cart drawer
   Isolated per-section; safe to have multiple on one page.
   ========================================================================== */
(function () {
  'use strict';

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP',
      });
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function showToast(message) {
    var toast = document.querySelector('.fp-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'fp-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  /* Try every reasonable way to open the store's cart drawer after adding.
     Falls back to a toast if no drawer is present. */
  function openCartDrawer() {
    // Let the theme / drawer know the cart changed.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));

    // Most custom drawers open by clicking the cart trigger.
    var trigger = document.querySelector('[data-cart-drawer-open]');
    if (trigger) {
      trigger.click();
      return true;
    }
    return false;
  }

  function initSection(root) {
    if (root._fpInit) return;
    root._fpInit = true;

    var qtyInput = root.querySelector('[data-fp-qty-input]');
    var qtyUp = root.querySelector('[data-fp-qty-up]');
    var qtyDown = root.querySelector('[data-fp-qty-down]');
    var select = root.querySelector('[data-fp-variant-select]');
    var priceEl = root.querySelector('[data-fp-price]');
    var addBtn = root.querySelector('[data-fp-add]');

    /* ---- Quantity ---- */
    function clampQty() {
      var n = parseInt(qtyInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      qtyInput.value = n;
      return n;
    }
    if (qtyUp) {
      qtyUp.addEventListener('click', function () {
        qtyInput.value = clampQty() + 1;
      });
    }
    if (qtyDown) {
      qtyDown.addEventListener('click', function () {
        qtyInput.value = Math.max(1, clampQty() - 1);
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', clampQty);
    }

    /* ---- Variant selection ---- */
    if (select && priceEl) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var price = opt && opt.getAttribute('data-price');
        if (price) priceEl.textContent = price;
      });
    }

    /* ---- Add to cart ---- */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.hasAttribute('disabled')) return;

        var variantId;
        if (select) {
          variantId = select.value;
          if (!variantId) {
            select.focus();
            showToast('Please choose an option first.');
            return;
          }
        } else {
          // Single-variant product: id is baked into the button if present.
          variantId = addBtn.getAttribute('data-variant-id');
        }

        if (!variantId) {
          showToast('This product is unavailable.');
          return;
        }

        var quantity = qtyInput ? clampQty() : 1;
        var label = addBtn.textContent;
        addBtn.classList.add('is-loading');
        addBtn.textContent = 'Adding…';

        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: quantity }),
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error((data && data.description) || 'Could not add to cart.');
              });
            }
            return res.json();
          })
          .then(function () {
            addBtn.classList.remove('is-loading');
            addBtn.textContent = label;
            var opened = openCartDrawer();
            if (!opened) showToast('Added to cart.');
          })
          .catch(function (err) {
            addBtn.classList.remove('is-loading');
            addBtn.textContent = label;
            showToast(err.message || 'Something went wrong.');
          });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-fp-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the merchant edits the section in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-fp-section]');
    if (root) initSection(root);
  });
})();
